import { render, staticRenderFns } from "./User.vue?vue&type=template&id=81e3617e&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"
import style0 from "./User.vue?vue&type=style&index=0&id=81e3617e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e3617e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81e3617e')) {
      api.createRecord('81e3617e', component.options)
    } else {
      api.reload('81e3617e', component.options)
    }
    module.hot.accept("./User.vue?vue&type=template&id=81e3617e&scoped=true", function () {
      api.rerender('81e3617e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Search/Result/User.vue"
export default component.exports